import { render, staticRenderFns } from "./GetAccountAd.vue?vue&type=template&id=fdb702a4&scoped=true&lang=pug&"
import script from "./GetAccountAd.vue?vue&type=script&lang=js&"
export * from "./GetAccountAd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb702a4",
  null
  
)

export default component.exports